module.exports = __webpack_public_path__ + "static/media/maternity1.20414773.jpg";